import { px2rem } from "@bedrock/utils"
import React from "react"
import { ProScreenAdapter, useScreenAdapterContext } from '@bedrock/eed-react';

const ScreenZoomSetting = () => {
  const adapterConfig = useScreenAdapterContext();
  console.log(adapterConfig, 'adapterConfig');

  return (
    <ProScreenAdapter {...adapterConfig}>
      <span>屏幕缩放设置</span>
    </ProScreenAdapter>
  );
}

export default ScreenZoomSetting;
